'use client'

import { Box, Grid, Stack, Typography } from "@mui/material";
import { useTranslations } from "next-intl";

const AirxVideo = () => {
    const t = useTranslations("ServicePage.airx_video");

    const VIDEO_CHECKIN_PLANS = [
        {
            titleKey: "plan_a_title",
            priceKeys: ["plan_a_price_1", "plan_a_price_2"],
            featureKeys: ["plan_a_feature_1"],
            noteKey: "plan_a_note",
        },
        {
            titleKey: "plan_b_title",
            priceKeys: ["plan_b_price_1", "plan_b_price_2"],
            featureKeys: ["plan_b_feature_1", "plan_b_feature_2"],
            noteKey: "plan_b_note",
        },
        {
            titleKey: "plan_c_title",
            priceKeys: ["plan_c_price_1", "plan_c_price_2"],
            featureKeys: ["plan_c_feature_1", "plan_c_feature_2"],
            noteKey: "plan_c_note",
        }
    ]

    return (
        <Box sx={{ py: { xs: 8, md: 12 }, px: 2, backgroundColor: "#ffffff" }}>
            <Box sx={{ maxWidth: "lg", margin: "auto" }}>
                {/* Header */}
                <Box sx={{ textAlign: "center", mb: 8 }}>
                    <span className="inline-block bg-[#F15859] text-white text-xs font-normal px-6 py-1.5 rounded-full mb-6 shadow-sm">
                        {t('chip')}
                    </span>
                    <Typography variant="h4" component="h2" sx={{ fontWeight: 800, color: "#132c4b", mb: 2 }}>
                        {t('title')}
                    </Typography>
                    <Typography variant="body1" sx={{ color: "#64748b", maxWidth: "800px", mx: "auto" }}>
                        {t('description')}
                    </Typography>
                </Box>

                <Grid container spacing={4} alignItems="stretch">
                    {VIDEO_CHECKIN_PLANS.map((plan, index) => {
                        const isRecommended = index === 1;
                        return (
                            <Grid size={{ xs: 12, md: 4 }} key={index} sx={{ display: 'flex' }}>
                                <Box
                                    sx={{
                                        position: 'relative',
                                        width: '100%',
                                        p: 4,
                                        borderRadius: "24px",
                                        backgroundColor: "white",
                                        border: isRecommended ? "2px solid #F15859" : "1px solid #e2e8f0",
                                        boxShadow: isRecommended ? "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)" : "none",
                                        display: 'flex',
                                        flexDirection: 'column',
                                    }}
                                >
                                    {isRecommended && (
                                        <Box
                                            sx={{
                                                position: 'absolute',
                                                top: -12,
                                                left: '50%',
                                                transform: 'translateX(-50%)',
                                                backgroundColor: '#F15859',
                                                color: 'white',
                                                px: 2,
                                                py: 0.5,
                                                borderRadius: '20px',
                                                fontSize: '0.875rem',
                                                fontWeight: 'bold',
                                                whiteSpace: 'nowrap',
                                            }}
                                        >
                                            {t('recommended_label')}
                                        </Box>
                                    )}
                                    <Typography variant="h6" sx={{ fontWeight: 800, color: "#132c4b", mb: 3, minHeight: '64px', display: 'flex', alignItems: 'center' }}>
                                        {t(plan.titleKey)}
                                    </Typography>

                                    <Box sx={{ mb: 3, p: 2, backgroundColor: "#f8fafc", borderRadius: "12px" }}>
                                        {plan.priceKeys.map((key, i) => (
                                            <Typography key={i} variant="body1" sx={{ color: "#1e293b", fontWeight: 700, mb: 0.5 }}>
                                                {t(key)}
                                            </Typography>
                                        ))}
                                    </Box>

                                    <Typography variant="subtitle2" sx={{ fontWeight: "bold", color: "#64748b", mb: 1 }}>
                                        {t('features_label')}
                                    </Typography>
                                    <Stack spacing={1} sx={{ mb: 3, flexGrow: 1 }}>
                                        {plan.featureKeys.map((key, i) => (
                                            <Box key={i} sx={{ display: 'flex', gap: 1 }}>
                                                <Typography sx={{ color: "#F15859", fontWeight: "bold" }}>✓</Typography>
                                                <Typography variant="body2" sx={{ color: "#475569" }}>
                                                    {t(key)}
                                                </Typography>
                                            </Box>
                                        ))}
                                    </Stack>

                                    <Box sx={{ mt: 'auto', pt: 3, borderTop: '1px solid #f1f5f9' }}>
                                        <Typography variant="subtitle2" sx={{ fontWeight: "bold", color: "#64748b", mb: 1 }}>
                                            {t('recommended_facilities_label')}
                                        </Typography>
                                        <Typography variant="caption" sx={{ color: "#64748b", display: "block" }}>
                                            {t(plan.noteKey)}
                                        </Typography>
                                    </Box>
                                </Box>
                            </Grid>
                        );
                    })}
                </Grid>
            </Box>
        </Box>
    )

}

export default AirxVideo;